import { render } from "./EmployeesView.vue?vue&type=template&id=73b2fd4f&ts=true"
import script from "./EmployeesView.vue?vue&type=script&lang=ts"
export * from "./EmployeesView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__